import useRouterHelper from 'hooks/useRouterHelper';

const useOnItemSelected = lessonId => {
  const { routePush } = useRouterHelper();
  function handleOnItemSelect(id, type) {
    return () => {
      if (id === lessonId) {
        routePush({
          removeSearch: ['newItem', 'lesson', 'type'],
        });
        return;
      }

      routePush({
        search: {
          lesson: id,
          type,
        },
        removeSearch: ['newItem'],
      });
    };
  }

  return {
    handleOnItemSelect,
  };
};

export default useOnItemSelected;
